var render = function render(){var _vm=this,_c=_vm._self._c;return _c('splash',{scopedSlots:_vm._u([{key:"splash-content",fn:function(){return [_c('v-icon',[_vm._v("error")]),_c('span',{staticClass:"pl-2 pr-2"},[_vm._v(_vm._s(`Page ${_vm.$route.path} doesnt exist`))]),_c('v-icon',[_vm._v("error")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }